"use client";
import { SmartLink } from "@/src/components/v2/SmartLink/SmartLink";
import SVG from "react-inlinesvg";
import CartIcon from "../../../images/icons/solid/cart-solid-navy.svg";
import { useQuoteData } from "@/src/hooks/useQuoteData";
import { TrackingUtils } from "@/src/utils/TrackingUtils";

export interface CartWidgetProps {
    id?: string;
    cartTitle: string;
    ctaLink?: string;
}

export const CartWidget = ({ id, cartTitle, ctaLink }: CartWidgetProps) => {
    const { quoteId, quotePetCount: petCount = 0 } = useQuoteData();
    const cartCtaLink = ctaLink || "/quote";

    const handleClick = () => {
        TrackingUtils.sendDataDogAction("cart_click", {
            id,
            petCount,
            quoteId
        });
    };

    return (
        <SmartLink
            tabIndex={0}
            target="_self"
            href={cartCtaLink}
            id={id}
            onClick={handleClick}
            aria-label={cartTitle}
            title={cartTitle}
            className="relative flex items-center text-button-md hover:bg-background-medium"
        >
            <SVG src={CartIcon.src} />
            {petCount > 0 && (
                <div className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-accent-primary-ada text-xs text-text-contrast">{petCount}</div>
            )}
        </SmartLink>
    );
};
